var BackOffice = (function (backOffice, $) {

    var doPolyfills = function () {

        /*  Used to polyfill missing native javascript api methods.
        **  Always create separate polyfills and wrap in a prototype existence check
        */


        /*
        **  https://caniuse.com/mdn-javascript_builtins_string_startswith
        **  Test case -
        **      alert("tre".startsWith("t")) - should return true
        */

        if (!String.prototype.startsWith) {
            Object.defineProperty(String.prototype,
                'startsWith',
                {
                    value: function (search, rawPos) {
                        var pos = rawPos > 0 ? rawPos | 0 : 0;
                        return this.substring(pos, pos + search.length) === search;
                    }
                });
        }
    };

    backOffice.Module({
        name: "Polyfills",
        init: function () {
            doPolyfills();
        }
    });

    return $.extend(backOffice, {});

})(BackOffice || {}, jQuery);